import { Chip } from '@mui/material'

import { AdminFulfillmentOrderListItem } from '../../../../redux/states/admin/orders/getAllFulfillmentOrdersForAdmin/getAllFulfillmentOrdersForAdmin.types'
import { TableColumn } from '../../../../shared/components/Table/Table.types'
import date, { dateTimeFormats } from '../../../../shared/functions/Date/date.functions'
import { stripPrefixFromId } from '../../../../shared/functions/ID/id.functions'
import { getStatusColor } from '../../../../shared/functions/Status/status.functions'

export const fulfillmentOrderTableColumns: TableColumn<AdminFulfillmentOrderListItem>[] = [
  {
    key: 'orderId',
    label: 'Order ID',
    render: (row: AdminFulfillmentOrderListItem) => stripPrefixFromId(row.orderId)
  },
  {
    key: 'createdAt',
    label: 'Created At',
    render: (row: AdminFulfillmentOrderListItem) => date(row.createdAt).format(dateTimeFormats.date.medium)
  },
  {
    key: 'description',
    label: 'Description'
  },
  {
    key: 'destination',
    label: 'Destination'
  },
  {
    key: 'sender',
    label: 'Sender',
    render: (row: AdminFulfillmentOrderListItem) => row.senderName
  },
  {
    key: 'senderEmail',
    label: 'Sender Email',
    render: (row: AdminFulfillmentOrderListItem) => row.senderEmail
  },
  {
    key: 'recipient',
    label: 'Recipient',
    render: (row: AdminFulfillmentOrderListItem) => row.recipientName
  },
  {
    key: 'traveler',
    label: 'Traveler',
    render: (row: AdminFulfillmentOrderListItem) => {
      if (row.travelerFirstName || row.travelerLastName) {
        return `${row.travelerFirstName || ''} ${row.travelerLastName || ''}`.trim()
      }

      return '-'
    }
  },
  {
    key: 'status',
    label: 'Status',
    render: (row: AdminFulfillmentOrderListItem) => (
      <Chip label={row.status.displayName || row.status.name} color={getStatusColor(row.status.name)} />
    )
  }
]
